module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-27.737f39e7.png";